import { gql } from '@apollo/client';

const GET_FEATURED_TOOLS = gql`
  query GetFeaturedTools($limit: Int, $offset: Int, $date: ISO8601Date!) {
    featuredTools(limit: $limit, offset: $offset) {
      items {
        id
        name
        description
        primaryImageUrl
        pricePerDayCents
        city
        postalCode
        nextAvailableDate(date: $date)
        latitude
        longitude
        ratingAverage
        reviewCount
        categories {
          id
          name
          code
        }
      }
      totalCount
    }
  }
`;

export {
  GET_FEATURED_TOOLS
}
